import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function dateMustBeAfterOrEqualThanToday(exceptionDates: Date[] = []): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    const date = control.value as Date;

    if (!date) {
      return null;
    }
    const dateIsIncludedOnExceptionsDates: boolean = exceptionDates.some((excDate) => {
      excDate.setHours(0, 0, 0, 0);
      return excDate.getTime() === date.getTime();
    });

    if (dateIsIncludedOnExceptionsDates) {
      return null;
    }

    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    if (date < currentDate) {
      return {
        description: 'No puedes ingresar una fecha inferior a la fecha actual. Por favor intenta con otra.',
        code: '300',
      };
    }

    return null;
  };
}
